


















































import { Component, Vue } from "vue-property-decorator";
import { GetStageInfo } from "@/services/stages/stageService";
import { StageInfo } from "@/services/stages/types";

@Component
export default class StageInfoModal extends Vue {
    stageInfo = {} as StageInfo;

    open(stageId: string) {
        GetStageInfo(stageId).then(response => {
            this.stageInfo = response;
            this.$bvModal.show("modal-stageInfo");
        });
    }

    settingsSolution(id: string) {
        return {
            name: "updateSolution",
            params: { solutionId: id }
        };
    }

    settingsDesign(id: string) {
        return {
            name: "updatetemplate",
            params: { templateId: id }
        };
    }

    hide() {
        this.$bvModal.hide("modal-stageInfo");
    }
}
